import { createSlice } from '@reduxjs/toolkit';
import { setSavedFilterCardStatus } from './filterSlice';


const initialStatus ={
    "customerId": "",
    "showroomId": "",
    "createdBy": "",
    "createdFrom": "",
    "createdTo": "",
    "vendorId": "",
    "orderCategory": "",
    "status": "NEW",
    "processedFrom": "",
    "processedTo": "",
    "processedBy": ""
  }

const statusSlice = createSlice({
  name: 'status',
  initialState: {
    status: initialStatus,
    hasFilter:false,
    cardStatus:"NEW",
  },
  reducers: {
    setSavedStatus: (state, action) => {
      state.status = action.payload;
    },
   
    setHasFilter:(state,action)=>{
      state.hasFilter=action.payload;

    },
    setFilterCardStatus  : (state, action) => {
      state.cardStatus = action.payload;
      state.status.status = action.payload;
    },

    clearStatusFilter: (state) => {
      state.hasFilter=false;
      state.status = initialStatus;
      state.cardStatus="NEW";
    },
  },
});

export const { setSavedStatus,setHasFilter,clearStatusFilter,setFilterCardStatus} = statusSlice.actions;
export default statusSlice.reducer;
